import { CategoriesTranslations } from "#i18n/translations/pt-BR/org/categories/index";

export const categories: CategoriesTranslations = {
	navTitle: "Categories",
	title: "Categories",
	subtitle: "View, reorder, create and edit your product categories.",
	searchPlaceholder: "Category, subcategory or product",
	addCategoryBtn: "Add category",
	amountOfCategories_one: "{{count}} category",
	amountOfCategories_other: "{{count}} categories",
	filterByBtn: "Filter order",
	categoryEmptyState: {
		title: "No category found",
		description: "There are no categories registered yet.",
	},
	subcategories_one: "{{count}} Subcategory",
	subcategories_other: "{{count}} Subcategories",
	products_one: "{{count}} Product",
	products_other: "{{count}} Products",
	chartAccountName: "Chart of Accounts",
	noCategoryDescription: "There is no description for this category yet.",
	addSubcategoryBtn: "Add subcategory in {{category}}",
	addProductBtn: "Add product in {{category}}",
	dialog: {
		create: {
			title: "Add category",
			save: "Save category",
		},
		createSubcategory: {
			title: "Add subcategory",
			save: "Save subcategory",
		},
		edit: {
			title: "Edit category",
			delete: "Delete category",
			deleteTooltip: "This category has associated products",
			save: "Save changes",
		},
		form: {
			name: {
				label: "Name",
				placeholder: "Set category name",
				requiredName: "Name is required",
			},
			priority: {
				label: "Priority position",
				tooltip: "Order in which it will appear among categories.",
				placeholder: "Set position or reorder in list later",
				requiredPriority: "Priority level is required",
				maxPriority: "This number is too big",
			},
			printOrder: {
				label: "Delivery phase",
				tooltip:
					"Category for automatic course phasing.<br>The operator will be able to reorder at POS if necessary.",
				placeholder: "Assign automatic phase",
				requiredPrintOrder: "Category phase is required",
				invalidPrintOrder: "Invalid category phase",
			},
			chartAccount: {
				label: "Chart of accounts",
				tooltip: "The chart of accounts defines the category's accounting account.",
				placeholder: "Select",
			},
			description: {
				label: "Category description",
				placeholder: "Describe category",
			},
		},
	},
	modal: {
		delete: {
			title: "Do you want to delete the category?",
			description:
				"Upon confirmation, the category will be deleted and the action cannot be undone.",
			confirm: "Delete category",
			cancel: "Cancel",
		},
	},
	inputImage: {
		addImage: "Add image",
		infoTypeAndSize: "File type {{type}} up to {{size}}MB",
		infoOnlyType: "File type {{type}}",
		infoOnlyMaxSize: "{{size}}MB",
	},
	productToOrg: {
		nameLabel: "Name",
		hasAlcoholLabel: "Contains alcohol",
		createDialogTitle: "Create product",
		editDialogTitle: "Edit product",
		createProductBtn: "Create product",
		editProductBtn: "Edit product",
		validation: {
			systemProduct: {
				required: "System product is required",
			},
		},
	},
};
